import { render, staticRenderFns } from "./GoodItem.vue?vue&type=template&id=0d36e68c&scoped=true&"
import script from "./GoodItem.vue?vue&type=script&lang=js&"
export * from "./GoodItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodItem.vue?vue&type=style&index=0&id=0d36e68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36e68c",
  null
  
)

export default component.exports